import React from "react";

const BUBBLE_WIDTHS = ["55%", "40%", "65%", "35%", "50%"] as const;
const SIDES = ["other", "own", "other", "own", "other"] as const;

interface Props {
  showHeader?: boolean;
}

function ChatSkeleton({ showHeader = false }: Props) {
  return (
    <div className="chat-skeleton">
      {showHeader && (
        <div className="chat-skeleton__header">
          <div className="chat-skeleton__header-back chat-skeleton__pulse" />
          <div className="chat-skeleton__header-avatar chat-skeleton__pulse" />
          <div className="chat-skeleton__header-info">
            <div className="chat-skeleton__header-name chat-skeleton__pulse" />
            <div className="chat-skeleton__header-sub chat-skeleton__pulse" />
          </div>
        </div>
      )}
      <div className="chat-skeleton__messages">
        {BUBBLE_WIDTHS.map((width, i) => (
          <div key={i} className={`chat-skeleton__bubble chat-skeleton__bubble--${SIDES[i]}`}>
            <div className="chat-skeleton__bubble-body chat-skeleton__pulse" style={{ width }} />
          </div>
        ))}
      </div>
      {showHeader && (
        <div className="chat-skeleton__input">
          <div className="chat-skeleton__input-icon chat-skeleton__pulse" />
          <div className="chat-skeleton__input-field chat-skeleton__pulse" />
          <div className="chat-skeleton__input-send" />
        </div>
      )}
    </div>
  );
}

export default ChatSkeleton;
